<template>
    <div class="add-ending-page">
        <app-header 
            :position="'fixed'"
            :top="'0px'"
            :background="'transparent'"
            @clickBack="$router.push('/video-editor')"
            @clickMenu="change_menu(context, true)"
        />

        <div class="add-ending-page__title">
            Необходимо добавить концовку
        </div>

        <div class="add-ending-page__descr">
            Для того чтобы у вашего видео было логичное завершение, необходимо добавить специальное видео-концовку.
        </div>
        
        <div class="add-ending-page__button-wrapper">
            <div class="add-ending-page__button"
                @click="$router.push('/add-ending-select')"
            >
                Добавить концовку
            </div>
        </div>

        <transition 
            name="fade-menu" 
            appear
            mode="out-in"
        >
            <app-menu 
                v-if="menu"
                idLogoMenu="header-component__menu"
                @clickLink="change_menu(context, false)"
                @clickOutside="change_menu(context, false)"
            />
        </transition >


        <transition 
            name="fade-overlay" 
            appear
            mode="out-in"
        >
            <app-overlay 
                v-if="overlay"
            />
        </transition>
    </div>
</template>

<script>

    const AppHeader = () => import('@/components/header.vue')
    const AppMenu = () => import('@/components/menu.vue')
    const AppOverlay = () => import('@/components/overlay.vue')

    import change_menu from "@/views/theme/modules/change_menu";

    export default {
        data() {
            return {
                context: this,
                overlay: false,
                menu: false
            }
        },
        components: {
            AppHeader,
            AppMenu,
            AppOverlay
        },
        methods: {
          change_menu,
        }
    }
</script>

<style lang="less">
    .add-ending-page {
        background-color: #2F1F4C;
        width: 100%;
        height: calc(var(--vh, 1vh) * 100);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        position: relative;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Bold.less';

    .add-ending-page__title {
        font-size: 22px;
        line-height: 28px;
        text-align: center;
        color: #FFFFFF;
        font-family: 'Montserrat-Bold';
        margin-left: 32px;
        margin-right: 32px;
    }

    @import '~/assets/fonts/roboto/Roboto-Light.less';

    .add-ending-page__descr {
        font-size: 15px;
        line-height: 22px;
        font-family: 'Roboto-Light';
        text-align: center;
        color: #FFFFFF;
        margin-top: 16px;
        margin-left: 43px;
        margin-right: 43px;
    }

    @import '~/assets/fonts/montserrat/Montserrat-Medium.less';

    .add-ending-page__button-wrapper {
        width: 100%;
        position: absolute;
        bottom: 16px;
        padding-left: 16px;
        padding-right: 16px;
    }

    .add-ending-page__button {
        height: 44px;
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #FFFFFF;
        color: #31283D;
        border-radius: 5px;
        margin: 0 auto;
        margin-top: 12px;
        cursor: pointer;
        font-family: 'Montserrat-Medium';
    }
</style>